import React from 'react';
import GameMap from './logic/GameMap';
import { mapConfigs } from './MapConfig/mapConfigs';
import SafariZoneTimer from '../../components/SafariZoneTimer';
import withSafariZoneProtection from '../../components/SafariZoneProtection';

const SafariZoneWest = () => {
  return (
    <>
      <GameMap config={mapConfigs.safariZoneWest} />
      <SafariZoneTimer />
    </>
  );
};

export default withSafariZoneProtection(SafariZoneWest);
